/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloBodegasPersonas from 'Infotrack@Modelos/smartStock/bodegasPersonas';
import IBodegasPersonas from 'Infotrack@Modelos/smartStock/bodegasPersonas/entidades/bodegasPersonas';
import IBodegasPersonasFiltro from 'Infotrack@Modelos/smartStock/bodegasPersonas/entidades/bodegasPersonasFiltro';

export default class ControladorModeloBodegasPersonas {
    private modeloBodegasPersonas: ModeloBodegasPersonas;
    constructor() {
        this.modeloBodegasPersonas = new ModeloBodegasPersonas();
    }

    public consultarBodegasPersonas() {
        return this.modeloBodegasPersonas.consultarBodegasPersonas().then(({ data: { Entidades } }) => Entidades);
    }

    public consultarBodegasPersonasCompuesta(bodegasPersonas: IBodegasPersonasFiltro) {
        return this.modeloBodegasPersonas
            .consultarBodegasPersonasCompuesta(bodegasPersonas)
            .then(({ data: { Entidades } }) => Entidades);
    }

    public async crearBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        await this.modeloBodegasPersonas.crearBodegasPersonas(bodegasPersonas);
    }

    public async editarBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        await this.modeloBodegasPersonas.editarBodegasPersonas(bodegasPersonas);
    }
    public async eliminarBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        await this.modeloBodegasPersonas.eliminarBodegasPersonas(bodegasPersonas);
    }

    public validarEntidad(bodegasPersonas: IBodegasPersonas): boolean {
        if (bodegasPersonas.PersonaId === '') {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
